<div class="searchBox" [ngStyle]="{'width': (config.width || 100) + 'px'}">
    <span><img src="assets/images/magnify.svg"></span>
    <span class="lato-regular-dark">
        <input type="text" [placeholder]="config.placeholder || 'Search'" [(ngModel)]="searchValue" [ngStyle]="{'width': (searchValue == '')? ((config.width || 100) - 48) + 'px':((config.width || 100) - 76) + 'px'}" (input)="onSearchChange($event.target)">
    </span>
    <button class="clear-search" *ngIf="searchValue != ''" (click)="clearSearch()">
        <img src="assets/images/close.svg"/>
    </button>
</div>